import UserEventsDialog from '@/components/userevents/UserEventsDialog';
import PersonOutline from '@mui/icons-material/PersonOutline';
import { FC, useState } from 'react';
import StyledTreeItem from './StyledTreeItem';
import TreeLabel from './TreeLabel';

const TreeUserEvents: FC = () => {
  const [openManager, setOpenManager] = useState(false);

  return (
    <>
      <StyledTreeItem
        itemId='user.events'
        label={<TreeLabel icon={PersonOutline} label='User Events' />}
        onClick={() => setOpenManager(true)}
      />
      <UserEventsDialog open={openManager} onClose={() => setOpenManager(false)} />
    </>
  );
};

export default TreeUserEvents;
